import React from "react";
import {
  TimelineTypeEnum
} from "../../../Components/DetailsView/History/History";
import { DashboardTitle } from "../Dashboard";
import { FormattedMessage } from "react-intl";
import { useDashboardKey } from "../DashboardQueryHelper";
import { ReportHistory } from "../../../Components/DetailsView/History/ReportHistory";

const DealsHistory = () => {
  const key = useDashboardKey();

  return (
    <>
      <DashboardTitle
        className="mb-0 px-4 fs-20"
        text={<FormattedMessage id={"HISTORY_DEALS"} />}
      />
      <ReportHistory
        type={TimelineTypeEnum.Deal}
        reportsType={"Deals"}
        key={key}
        noFilter
        onMouseDown={(e) => e.stopPropagation()}
        disableTabs
        deals
      />
    </>
  );
};

export default DealsHistory;
